<template>
  <div class="footer-area-wrapper" :class="FooterStyle">
    <div class="footer-area section-space--ptb_90">
      <div class="container">
        <div class="row footer-widget-wrapper justify-content-between">
          <div class="col-lg-4 col-md-6 footer-widget">
            <div class="footer-widget__logo text-center">
              <img src="../assets/img/logo/logo.png" class="logo-mobile py-2" alt="mhp-finance.de Logo">
            </div>
          </div>
          <div class="col-lg-4 col-md-6 footer-widget text-center">
            <h6 class="footer-widget__title mb-20">Rechtliches</h6>
            <ul class="footer-widget__list">
              <li v-for="(link, key) in links" :key="key">
                <router-link :to="link.to" class="hover-style-link">{{ link.title }}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright-area border-top section-space--ptb_30">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-12 text-center">
            <span class="copyright-text">© 2020 mhp-finance.de - Alle Rechte vorbehalten</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterMain',
  props: ["FooterStyle"],
  data() {
    return {
      links: [
        {
          title: 'Impressum',
          to: {
            path: '/impressum'
          }
        },
        {
          title: 'Datenschutz',
          to: {
            path: '/datenschutz'
          }
        }
      ]
    }
  }
}
</script>